import { Link, Text } from '@vkontakte/vkui';
import classNames from 'clsx';
import familyCalendarImg from 'img/familyBuyTariffsModal/familyCalendar.png';
import familyDocsImg from 'img/familyBuyTariffsModal/familyDocs.png';
import familyFoldersImg from 'img/familyBuyTariffsModal/familyFolders.png';
import infiniteSpaceImg from 'img/familyBuyTariffsModal/infiniteSpace.png';
import mailSpaceImg from 'img/familyBuyTariffsModal/mailSpace.png';
import membersImg from 'img/familyBuyTariffsModal/members.png';
import React, { type ReactElement } from 'react';
import { familyCalendarsModalTariffsReverse } from 'reactApp/appHelpers/featuresHelpers/features/familyFunctions';

import styles from './FamilyBenefits.css';

interface Benefits {
    text: string | ReactElement;
    image: string;
}

const benefits: Array<Benefits> = [
    {
        text: 'Добавление ещё\n3 участников',
        image: membersImg,
    },
    {
        text: 'Безлимитная автозагрузка фото с телефона — у всех',
        image: infiniteSpaceImg,
    },
    {
        text: 'Распознавание документов семьи',
        image: familyDocsImg,
    },
    {
        text: 'Семейные папки, альбомы\nи документы',
        image: familyFoldersImg,
    },
    {
        text: 'Семейный календарь для общих дел',
        image: familyCalendarImg,
    },
    {
        text: (
            <>
                И все{' '}
                <Link href="https://cloud.mail.ru/promo/quota#benefits" target="_blank">
                    возможности
                </Link>{' '}
                подписки Mail Space
            </>
        ),
        image: mailSpaceImg,
    },
];

const BenefitsItem: React.FC<Benefits> = ({ text, image }) => {
    return (
        <div className={styles.item}>
            <img src={image} alt="Иконка преимущества" className={styles.image} />
            <Text className={styles.text}>{text}</Text>
        </div>
    );
};

export const FamilyBenefits: React.FC = () => {
    return (
        <div className={classNames(styles.root, { [styles.reversedRoot]: familyCalendarsModalTariffsReverse })}>
            <Text className={styles.title} weight="2">
                Что входит в семейную подписку Mail Space:
            </Text>
            <div className={styles.benefitsList}>
                {benefits.map(({ text, image }, index) => (
                    <BenefitsItem key={index} text={text} image={image} />
                ))}
            </div>
        </div>
    );
};
